export default __webpack_public_path__ + "static/media/contact-image.49c320bd.png";